import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { LoginFormTypes } from "models/formTypes";
import { ResetPasswordParams } from "models/propTypes/urlParamsTypes";
//#endregion
//#region components
import { useParams } from "react-router-dom";
import ResetPasswordForm from "./resetPasswordForm";
import { useAuthService } from "serviceHooks";
//#endregion
import * as Yup from "yup";

const ResetPasswordFormContainer: ForwardRefRenderFunction<FormHandles, BaseFormComponentProps> = (props, ref) => {
  const authService = useAuthService();
  const params = useParams<ResetPasswordParams>();

  const validationSchema = Yup.object<LoginFormTypes.ResetPassword>({
    password: Yup.string().required(TranslationKeys.Validations.Required),
    confirmPassword: Yup.string().required(TranslationKeys.Validations.Required),
  });

  const defaultValues: LoginFormTypes.ResetPassword = {
    password: "",
    confirmPassword: "",
  };

  const handleSubmit = (values: LoginFormTypes.ResetPassword) => {
    const ticket = params.ticket;
    return authService.resetPassword({
      ticket,
      password: values.password,
      confirmPassword: values.confirmPassword,
    });
  };

  return (
    <ResetPasswordForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      handleSubmit={handleSubmit}
    />
  );
};

export default forwardRef(ResetPasswordFormContainer);
